import { render, staticRenderFns } from "./pubMenu.vue?vue&type=template&id=2cd89505&"
import script from "./pubMenu.vue?vue&type=script&lang=js&"
export * from "./pubMenu.vue?vue&type=script&lang=js&"
import style0 from "./pubMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pubMenu.vue"
export default component.exports